<template>
  <div>
    <div :class="paddingClass">
      <slot />
    </div>
    <div v-tooltip="buttonTooltip">
      <button
        class="tw-inline-flex tw-w-full tw-items-center tw-justify-center tw-rounded-b-xl tw-bg-primary-500 tw-py-3 tw-text-sm tw-text-white tw-transition-colors hover:tw-bg-primary-400 focus:tw-bg-primary-500 focus:tw-outline-none"
        :class="{
          'disabled:tw-cursor-not-allowed disabled:tw-bg-primary-200 disabled:tw-text-primary-300':
            !isButtonLoading,
        }"
        @click="emit('submit')"
        :disabled="isButtonDisabled || isButtonLoading"
        :test_id="testId"
      >
        {{ footerButtonText }}
        <LoadingCircle
          v-if="isButtonLoading"
          size="16"
          color="tw-text-white"
          class="tw-ml-2"
        />
      </button>
    </div>
  </div>
</template>

<script setup>
import LoadingCircle from '../../LoadingCircle.vue'
import { computed, useAttrs } from 'vue'

const emit = defineEmits(['submit'])

defineProps({
  footerButtonText: {
    type: String,
    default: 'Send',
  },
  isButtonDisabled: {
    type: Boolean,
    default: false,
  },
  isButtonLoading: {
    type: Boolean,
    default: false,
  },
  buttonTooltip: {
    type: String,
    default: '',
  },
  paddingClass: {
    type: String,
    default: 'tw-p-6',
  },
})

const attrs = useAttrs()

const testId = computed(() =>
  attrs.test_id ? attrs.test_id + '-button' : 'modal-save',
)
</script>
